var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDisabilityInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12622",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12623",
    d: "M5 7h14a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12624",
    d: "M9.5 13.5h5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12625",
    d: "M12 11v5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12626",
    d: "M16 7l-.621-2.485A2 2 0 0013.438 3h-2.877a2 2 0 00-1.94 1.515L8 7",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default SvgDisabilityInsurance;


//////////////////
// WEBPACK FOOTER
// ./src/icons/disabilityInsurance.svg
// module id = 472
// module chunks = 101